import { render, staticRenderFns } from "./EditCoverImage.vue?vue&type=template&id=f671e290&scoped=true&"
import script from "./EditCoverImage.vue?vue&type=script&lang=ts&"
export * from "./EditCoverImage.vue?vue&type=script&lang=ts&"
import style0 from "./EditCoverImage.vue?vue&type=style&index=0&id=f671e290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f671e290",
  null
  
)

export default component.exports